import { useEffect, useState } from 'react';
import { configuredPaddle, previewPersonalPrices, type LocalizedPrices } from './paddle-client';
import type { PublicCommerce } from './commerce';

export function usePaddlePrices(config: PublicCommerce | null | undefined) {
  const [prices, setPrices] = useState<LocalizedPrices | null>(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    setPrices(null); setError('');
    if (!config) return;
    const load = async () => {
      if (!config.plan.priceId) throw new Error('Personal billing prices are not configured.');
      return previewPersonalPrices(await configuredPaddle(config), config.plan.priceId, config.countryCode);
    };
    void load().then(value => { if (active) setPrices(value); }).catch(cause => {
      if (active) setError(cause instanceof Error ? cause.message : 'Prices are temporarily unavailable.');
    });
    return () => { active = false; };
  }, [config]);
  return { prices, error };
}
